import { useMediaQuery } from "../../hooks/useMediaQuery.js";

/**
 * Below this the docked side panel would crush the main content, so it is
 * hidden and the copilot chat lives in the expanded modal instead
 * (see `CopilotShell` and `AskAlpharunButton`).
 */
const DOCKED_PANEL_MEDIA_QUERY = "(min-width: 1024px)";

/** Whether the viewport is wide enough to dock the copilot panel. */
export function useIsDockedPanelViewport(): boolean {
  return useMediaQuery(DOCKED_PANEL_MEDIA_QUERY);
}
